export default __webpack_public_path__ + "static/media/page industries limited.cfa42ebe.jpg";